import { memo, useCallback, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { formatDecimalPlaces } from '../../../helpers/functions/format-decimal-places'
import { useGetMyProfileMini } from '../../../hooks/queries/profile/use-get-my-profile-mini'
import { useGetUserCoins } from '../../../hooks/queries/profile/use-get-user-coins'
import { useListenerMessage } from '../../../hooks/subscription/use-listener-message'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { LiveGiftsAnimations } from '../../../types/lives/animations'
import coin from './components/gifts-container/assets/coin.png'

// const handleVoltar = () => {
//   if (typeof window !== 'undefined' && 'ReactNativeWebView' in window) {
//     ;(
//       window as unknown as {
//         ReactNativeWebView: { postMessage: (m: string) => void }
//       }
//     ).ReactNativeWebView.postMessage('close-modal')
//   }
// }

const LIVE_GIFTS_ANIMATIONS = '/LIVE-GIFTS-ANIMATIONS'

export const Coins = memo(() => {
  const { user } = useGetMyProfileMini()
  const { refetch } = useGetUserCoins()

  const coinsInLive = useGlobalStore(useShallow((state) => state.coinsInLive))
  const liveId = useGlobalStore(useShallow((state) => state.liveId))

  const coins = coinsInLive || user?.coins

  useEffect(() => {
    refetch()
  }, [refetch])

  useListenerMessage(refetch)

  const updateUserCoins = useCallback(
    ({ message }: LiveGiftsAnimations) => {
      if (message?.userSentId === user?.id) {
        const returnForUser = message?.returnForUser?.at(-1)

        if (typeof returnForUser?.newCoins === 'number') {
          const newCoins =
            returnForUser?.newCoins < 0 ? 0 : returnForUser?.newCoins

          useGlobalStore.setState({ coinsInLive: newCoins })
        }
      }
    },
    [user?.id],
  )

  // const handleOpenModalRecharge = useCallback(() => {
  //   if ('ReactNativeWebView' in window) {
  //     // @ts-ignore
  //     window.ReactNativeWebView.postMessage('recharge')
  //   }
  // }, [])

  useSub<LiveGiftsAnimations>({
    endpoint: `${LIVE_GIFTS_ANIMATIONS}/${liveId}`,
    skip: !liveId,
    onData: updateUserCoins,
  })

  return (
    <div className="flex h-full w-full flex-col bg-[#150a1e]/95">
      {/* <div className="absolute top-3 right-2 z-20">
        <button
          type="button"
          onClick={handleVoltar}
          className="text-sm font-medium text-white underline hover:opacity-90"
        >
          Voltar
        </button>
      </div> */}
      <div className="flex w-full flex-1 flex-row items-center justify-between px-6">
        <div className="flex flex-row items-center gap-1.5 rounded-full bg-white/10 px-3 py-1">
          <img src={coin} className="h-3.5 w-3.5" />
          <span className="text-sm font-semibold text-white">
            {formatDecimalPlaces(coins ?? 0)}
          </span>
        </div>
      </div>
    </div>
  )
})
